import React from 'react'

import {
  Layout,
  Grid,
  GridItem,
  Header,
  Intro,
  Section,
} from '../../../../components'

import { Link } from 'gatsby'

import mint from '../../../../images/the-mint.svg'
import treasury from '../../../../images/the-treasury.svg'
import portfolio from '../../../../images/the-portfolio.svg'

import data from './data.json'

import './style.scss'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        title={data.title}
        state="design"
      />
      <Layout
        subtitle={data.subtitle}
        slug={data.slug + '/design/'}
        site={data.site}
        state="design"
        title="M&amp;T Currency Design System"
        complete={true}
      >
        <Intro noBorder={true}>
          <p>
            The Currency design system helps designers, engineers and product
            teams work together to build more cohesive experiences across M&T
            Bank's line of digital products and services. Just like monetary
            systems are comprised of institutions and frameworks that support
            the circulation of money, the design system isn't just one thing.
            Currency is built of three parts that work together to maintain a
            consistent and cohesive design language at M&T.
            <br />
            <br />
            <strong>
              Each aspect of the system is designed to help you work smarter and
              faster and keep you trading in the right currency.
            </strong>
          </p>
        </Intro>
        <Section type="gray" className="naming floating">
          <Grid>
            <GridItem columns="4" className="l-padding-right--xxxlarge">
              <img
                className="naming__icon inline l-margin-bottom--xxxlarge"
                src={mint}
                alt="About Currency"
              />
              <h2 className="naming__title">
                <span class="unbold">The</span> Mint
              </h2>
              <div class="u-type--small u-type--italic">
                Currency Asset Libraries
              </div>
              <p class="naming__text">
                Our{' '}
                <a
                  className="link"
                  href="https://www.figma.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Figma Libraries
                </a>{' '}
                are where we print approved Currency assets and make them
                available for use. Designers can access these from the browser
                or from Sketch to implement them directly into their work.
              </p>
            </GridItem>
            <GridItem columns="4" className="l-padding-right--xxxlarge">
              <img
                className="naming__icon inline l-margin-bottom--xxxlarge"
                src={treasury}
                alt="About Currency"
              />
              <h2 className="naming__title">
                <span class="unbold">The</span> Treasury
              </h2>
              <div class="u-type--small u-type--italic">
                CurrencySCSS Repository
              </div>
              <p class="naming__text">
                Our code repositories are how we make the transaction from
                visual design prototype to user interface seamless. Developers
                can access out-of-the-box styles or take advantage of utility
                classes when necessary to make changes.
              </p>
            </GridItem>
            <GridItem columns="4" className="l-padding-right--xxxlarge">
              <img
                className="naming__icon inline l-margin-bottom--xxxlarge"
                src={portfolio}
                alt="About Currency"
              />
              <h2 className="naming__title">
                <span class="unbold">The</span> Portfolio
              </h2>
              <div class="u-type--small u-type--italic">
                Currency Documentation Site
              </div>
              <p class="naming__text">
                Our site is where you learn how Currency works for you. The
                documentation around the concepts in the system guide you in
                approaching the problems Currency is designed to solve so you
                can make informed design decisions. Alongside the documentation,
                you'll find live examples of our finalized designs backed by
                fully-functional, copiable HTML code snippets for a full
                service, contextual experience.
              </p>
            </GridItem>
          </Grid>
        </Section>
        <div className="designer-developer">
          <Grid>
            <GridItem columns="6" className="l-padding--none">
              <Link
                to={'/' + data.site + '/general/getting-started/design'}
                className="designer-developer__button designer-developer__button--designer"
              >
                I am a <div class="title">designer.</div>
                <div class="sub-text">
                  Start Designing Now{' '}
                  <i class="icon icon--arrow-with-tail-right"></i>
                </div>
              </Link>
            </GridItem>
            <GridItem columns="6" className="l-padding--none">
              <Link
                to={'/' + data.site + '/general/getting-started/develop'}
                className="designer-developer__button designer-developer__button--developer"
              >
                I am a <div class="title">developer.</div>
                <div class="sub-text">
                  Start Developing Now{' '}
                  <i class="icon icon--arrow-with-tail-right"></i>
                </div>
              </Link>
            </GridItem>
          </Grid>
        </div>

        <div className="explore-currency">
          <Grid>
            <GridItem
              columns="6"
              className="l-padding-right--xxxlarge l-padding-bottom--xxlarge"
            >
              <h3>Design</h3>
              <p>
                Learn about M&T Bank's design standards and how they are
                implemented within Currency.
              </p>
              <Link to={'/' + data.site + '/guidelines/color/design'}>
                Read Our Design Guidelines{' '}
              </Link>
            </GridItem>
            <GridItem
              columns="6"
              className="l-padding-right--xxxlarge l-padding-bottom--xxlarge"
            >
              <h3>Content</h3>
              <p>
                Learn how we communicate to our customers in order to provide a
                supportive banking experience.
              </p>
              <Link to={'/' + data.site + '/content/voice-tone/design'}>
                Read Our Content Guidelines{' '}
              </Link>
            </GridItem>
            <GridItem
              columns="6"
              className="l-padding-right--xxxlarge l-padding-bottom--xxlarge"
            >
              <h3>Components</h3>
              <p>
                Use Currency's components as the foundational building blocks of
                your interfaces.
              </p>
              <Link to={'/' + data.site + '/components/button/design'}>
                Browse Our Components{' '}
              </Link>
            </GridItem>
            <GridItem
              columns="6"
              className="l-padding-right--xxxlarge l-padding-bottom--xxlarge"
            >
              <h3>Patterns</h3>
              <p>
                See how Currency's patterns solve for common design elements and
                user actions.
              </p>
              <Link to={'/' + data.site + '/patterns/header/design'}>
                Browse Our Patterns{' '}
              </Link>
            </GridItem>
          </Grid>
        </div>
      </Layout>
    </>
  )
}
